import { find, get } from 'lodash-es'

const initialState = {
  speakers: [],
  loading: true,
  isCrudModalVisible: false,
  crudButtonState: 'idle',
  crudMode: 'new',
  sendInviteSpeakerId: null,
  addedSpeaker: null,
  maxNumOfSpeakers: 0,
  crudSpeakerId: null,
}

export default ({ actionNames }) =>
  (state = initialState, action = undefined) => {
    switch (action.type) {
      case actionNames.FETCH_SUCCESS: {
        return {
          ...state,
          loading: false,
          speakers: action.speakers,
        }
      }
      case actionNames.FETCH_SETTINGS_SUCCESS: {
        const maxWebinarSpeakersSetting = find(
          action.settings,
          (setting) => setting.setting === 'max_webinar_speakers'
        )

        return {
          ...state,
          maxNumOfSpeakers: parseInt(maxWebinarSpeakersSetting.value, 10),
        }
      }
      case actionNames.UPDATE_SPEAKERS: {
        return {
          ...state,
          speakers: action.speakers,
        }
      }
      case actionNames.FETCH_FAILURE: {
        return {
          ...state,
          loading: false,
        }
      }
      case actionNames.OPEN_CRUD_MODAL: {
        return {
          ...state,
          crudMode: get(action, 'payload[0]', 'new'),
          isCrudModalVisible: true,
          crudButtonState: 'idle',
          addedSpeaker: null,
          crudSpeakerId: get(action, 'payload[1]', null),
        }
      }
      case actionNames.CLOSE_CRUD_MODAL: {
        return {
          ...state,
          isCrudModalVisible: false,
          crudSpeakerId: null,
        }
      }
      case actionNames.SAVING: {
        return {
          ...state,
          crudButtonState: 'loading',
        }
      }
      case actionNames.SAVED_SUCCESS: {
        return {
          ...state,
          crudButtonState: 'success',
        }
      }
      case actionNames.SAVED_FAILURE: {
        return {
          ...state,
          crudButtonState: 'failure',
        }
      }
      case actionNames.SEND_INVITE_IDLE: {
        return {
          ...state,
          sendInviteSpeakerId: null,
        }
      }
      case actionNames.SEND_INVITE_LOADING: {
        return {
          ...state,
          sendInviteSpeakerId: action.speakerId,
        }
      }
      case actionNames.SPEAKER_ADDED_SUCCESS: {
        const { speakerId } = action
        const { speakers } = state

        return {
          ...state,
          addedSpeaker: find(
            speakers,
            (speaker) => speaker.live_speaker_id === speakerId
          ),
          crudMode: 'speaker-added',
          crudButtonState: 'idle',
        }
      }
      case actionNames.SPEAKER_INVITED_SUCCESS: {
        return {
          ...state,
          crudMode: 'invitation-sent',
        }
      }
      case actionNames.RESET_STORE_DATA: {
        return {
          ...initialState,
        }
      }
      case actionNames.UPDATE_ORDER: {
        return {
          ...state,
          speakers: action.speakers,
        }
      }
      default:
        return state
    }
  }
